// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.admin-sticker-packs .sticker-pack-form.dragging,
.admin-sticker-packs-edit .sticker-pack-form.dragging {
  cursor: grabbing;
}
.admin-sticker-packs .sticker-pack-form .form-group.flex-row label,
.admin-sticker-packs-edit .sticker-pack-form .form-group.flex-row label {
  flex: 0 0 10rem;
  align-self: center;
}
.admin-sticker-packs .sticker-pack-form .sticker-drop-overlay,
.admin-sticker-packs-edit .sticker-pack-form .sticker-drop-overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.12);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 5px dashed rgba(0, 0, 0, 0.5);
  border-radius: 1.5rem;
}
.admin-sticker-packs .sticker-pack-form fieldset,
.admin-sticker-packs-edit .sticker-pack-form fieldset {
  position: relative;
}
.admin-sticker-packs .sticker-pack-form .sticker-drop,
.admin-sticker-packs-edit .sticker-pack-form .sticker-drop {
  display: absolute !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.admin-sticker-packs .sticker-pack-form .sticker-row,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row {
  display: grid;
  grid-template-columns: 4rem 4rem 1fr 2fr 15rem;
  gap: 1rem;
  padding-bottom: 1rem;
}
.admin-sticker-packs .sticker-pack-form .sticker-row img,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row img {
  max-height: 4rem;
  max-width: 4rem;
}
.admin-sticker-packs .sticker-pack-form .sticker-row .form-group.flex-row,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row .form-group.flex-row {
  margin: 0;
}
.admin-sticker-packs .sticker-pack-form .sticker-row .form-group.flex-row input.form-control,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row .form-group.flex-row input.form-control {
  height: 4rem;
}
.admin-sticker-packs .sticker-pack-form .sticker-row .drag-handle,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row .drag-handle {
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
}
.admin-sticker-packs .sticker-pack-form .sticker-row.dragging,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row.dragging {
  opacity: 0.5;
}
.admin-sticker-packs .sticker-pack-form .sticker-row.over,
.admin-sticker-packs-edit .sticker-pack-form .sticker-row.over {
  padding-top: 4rem;
}
.admin-sticker-packs .sticker-pack-form .end-row,
.admin-sticker-packs-edit .sticker-pack-form .end-row {
  height: 4rem;
}
.admin-sticker-packs .sticker-pack-form .actions,
.admin-sticker-packs-edit .sticker-pack-form .actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
.admin-sticker-packs .sticker-pack-form .Select-control,
.admin-sticker-packs .sticker-pack-form .Select-value,
.admin-sticker-packs-edit .sticker-pack-form .Select-control,
.admin-sticker-packs-edit .sticker-pack-form .Select-value {
  height: unset;
}
.admin-sticker-packs .sticker-pack-form .Select-control .Select-value-icon,
.admin-sticker-packs .sticker-pack-form .Select-value .Select-value-icon,
.admin-sticker-packs-edit .sticker-pack-form .Select-control .Select-value-icon,
.admin-sticker-packs-edit .sticker-pack-form .Select-value .Select-value-icon {
  color: transparent;
  position: relative;
}
.admin-sticker-packs .sticker-pack-form .Select-control .Select-value-icon:before,
.admin-sticker-packs .sticker-pack-form .Select-value .Select-value-icon:before,
.admin-sticker-packs-edit .sticker-pack-form .Select-control .Select-value-icon:before,
.admin-sticker-packs-edit .sticker-pack-form .Select-value .Select-value-icon:before {
  position: absolute;
  top: 0.3rem;
  left: 0.1rem;
  content: "close";
  font-family: "Material Icons";
  color: #007eff;
}
.admin-sticker-packs .sticker-pack-form .Select-control,
.admin-sticker-packs-edit .sticker-pack-form .Select-control {
  min-height: 3rem;
}
.admin-sticker-packs .sticker-pack-form .sticker-option,
.admin-sticker-packs-edit .sticker-pack-form .sticker-option {
  display: flex;
  align-items: center;
}
.admin-sticker-packs .sticker-pack-form .sticker-option img,
.admin-sticker-packs-edit .sticker-pack-form .sticker-option img {
  max-height: 4rem;
  max-width: 4rem;
  margin-right: 0.5rem;
}
.admin-sticker-packs .table-sticker,
.admin-sticker-packs-edit .table-sticker {
  height: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Admin/AdminStickerPacks/AdminStickerPacks.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAGI;;EACE,gBAAA;AACN;AAGM;;EACE,eAAA;EACA,kBAAA;AAAR;AAII;;EACE,kBAAA;EACA,+BAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,qBAAA;AADN;AAII;;EACE,kBAAA;AADN;AAII;;EACE,4BAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AADN;AAII;;EACE,aAAA;EACA,8CAAA;EACA,SAAA;EACA,oBAAA;AADN;AAGM;;EACE,gBAAA;EACA,eAAA;AAAR;AAGM;;EACE,SAAA;AAAR;AACQ;;EACE,YAAA;AAEV;AAEM;;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACR;AAEM;;EACE,YAAA;AACR;AAEM;;EACE,iBAAA;AACR;AAGI;;EACE,YAAA;AAAN;AAGI;;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAAN;AAGI;;;;EAEE,aAAA;AACN;AAAM;;;;EACE,kBAAA;EACA,kBAAA;AAKR;AAJQ;;;;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AASV;AALI;;EACE,gBAAA;AAQN;AANI;;EACE,aAAA;EACA,mBAAA;AASN;AARM;;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;AAWR;AAPE;;EACE,YAAA;AAUJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n.admin-sticker-packs,\n.admin-sticker-packs-edit {\n  .sticker-pack-form {\n    &.dragging {\n      cursor: grabbing;\n    }\n\n    .form-group.flex-row {\n      label {\n        flex: 0 0 10rem;\n        align-self: center;\n      }\n    }\n\n    .sticker-drop-overlay {\n      position: absolute;\n      background: rgba(0, 0, 0, 0.12);\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border: 5px dashed rgba(0, 0, 0, 0.5);\n      border-radius: 1.5rem;\n    }\n\n    fieldset {\n      position: relative;\n    }\n\n    .sticker-drop {\n      display: absolute !important;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n    }\n\n    .sticker-row {\n      display: grid;\n      grid-template-columns: 4rem 4rem 1fr 2fr 15rem;\n      gap: 1rem;\n      padding-bottom: 1rem;\n\n      img {\n        max-height: 4rem;\n        max-width: 4rem;\n      }\n\n      .form-group.flex-row {\n        margin: 0;\n        input.form-control {\n          height: 4rem;\n        }\n      }\n\n      .drag-handle {\n        cursor: grab;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      &.dragging {\n        opacity: 0.5;\n      }\n\n      &.over {\n        padding-top: 4rem;\n      }\n    }\n\n    .end-row {\n      height: 4rem;\n    }\n\n    .actions {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: 1rem;\n    }\n\n    .Select-control,\n    .Select-value {\n      height: unset;\n      .Select-value-icon {\n        color: transparent;\n        position: relative;\n        &:before {\n          position: absolute;\n          top: 0.3rem;\n          left: 0.1rem;\n          content: 'close';\n          font-family: 'Material Icons';\n          color: #007eff;\n        }\n      }\n    }\n    .Select-control {\n      min-height: 3rem;\n    }\n    .sticker-option {\n      display: flex;\n      align-items: center;\n      img {\n        max-height: 4rem;\n        max-width: 4rem;\n        margin-right: 0.5rem;\n      }\n    }\n  }\n  .table-sticker {\n    height: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
